import axios from "axios";
// Use for share bill online
const app_base_url = 'https://thana.la';
//const app_base_url = 'http://127.0.0.1:3000';

// base_url api
const base_url = 'https://thana.la/pos';
//const base_url = 'http://127.0.0.1:4500';

export default axios.create({
    baseURL: base_url
});

export const axiosPrivate = axios.create({
    baseURL: base_url,
    timeout: 30000, // 30 seconds timeout
    //headers: { 'Content-Type': 'application/json' },
    //headers: { 'Content-Type': 'multipart/form-data' }
});

// Use for req to api with out loggin then need to set static token to verify with api
export const axiosPrivateStatic = axios.create({
    baseURL: base_url,
    timeout: 30000, // 30 seconds timeout
    headers: {
        'Authorization': `Bearer jsfgfjguwrg8783wgbjs849h2fu3cnsvh8wyr8fhwfvi2g225`, // Your static token
        'Content-Type': 'application/json'
    }
});

export const api_ip = () => {
    return base_url
};

export const app_link = () => {
    return app_base_url
};